

export function escapeSpecialCharacters(str: string): string {
  // Backslash must be escaped for WIFI QR (MeCard) so scanners do not treat it as an escape prefix.
  return str.replace(/[\\$&+,:;=?@#|'<>.^*()%!-]/g, '\\$&')
}

export function safeDecodeURIComponent(str: string): string {
  try { return decodeURIComponent(str) } catch { return str }
}

